import React, { useEffect, useState } from 'react'
import { Card } from '@mui/material'
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import service from '../../api/services';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowCircleRightOutlined } from '@mui/icons-material';
const Index = () => {
    const params = useParams()
    const Navigate = useNavigate()
    const [allData, setAllData] = useState({})
    const getDetailById = async () => {
        try {
            const res = await service.users.getDetailById(params.id);
            console.log("asdfasdf", res)
            setAllData(res?.data?.data)
        } catch (error) {
            console.error('Error fetching user details:', error);
        }
    };
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    useEffect(() => {
        if (params?.id) {
            getDetailById();
        }
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Card className='glassmorphism-card' sx={{ padding: 3, boxShadow: 2 }}>
                <SoftBox borderRadius="lg" >
                            <SoftBox sx={{ display: 'flex', gap: 2 }}>
                                        <SoftBox
                                            variant="outlined"
                                            color="info"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => Navigate(-1)}
                                        >
                                            <ArrowCircleRightOutlined
                                                style={{ transform: "rotate(180deg)", color: "#141414" }}
                                            />
                                        </SoftBox>
                                        <SoftTypography variant="h6" fontWeight="bold" mb={3}>
                                            User Profile
                                        </SoftTypography>
                                    </SoftBox>
                   

                    <SoftBox display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={3}>
                        {/* Left Info Section */}
                        <SoftBox flex={1} >
                            {[{
                                label: "First Name",
                                value: allData?.firstName
                            }, {
                                label: "Last Name",
                                value: allData?.lastName
                            }, {
                                label: "Email",
                                value: allData?.email
                            }, {
                                label: "Contact Number",
                                value: allData?.mobileNumber
                            }, {
                                label: "Address",
                                value: `${allData?.city || '' }${allData?.state || ''}, ${allData?.country || ''}`
                            }].map((item, i) => (
                                <SoftBox display={'flex'} mb={3} key={i} gap={2}>
                                    <SoftTypography variant="button" fontWeight="bold" textTransform="capitalize">{item.label}</SoftTypography>
                                    <SoftTypography variant="button" fontWeight="bold" textTransform="capitalize">:</SoftTypography>
                                    <SoftTypography variant="button" fontWeight="regular" color="text">{item.value}</SoftTypography>
                                </SoftBox>
                            ))}
                        </SoftBox>

                        {/* Right Section - Map */}
                        <SoftBox
                            sx={{
                                width: '100%',
                                maxWidth: '600px',
                                borderRadius: 2,
                                overflow: 'hidden',
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                                border: '1px solid #e0e0e0',
                                backgroundColor: '#fff',
                                mt: { xs: 3, md: 0 }
                            }}
                        >

                            <iframe
                                width="100%"
                                height="300"
                                frameBorder="0"
                                style={{
                                    border: 0,
                                    borderRadius: '0 0 8px 8px',
                                    display: 'block',
                                }}
                                src={`https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${allData?.location?.coordinates?.[0]},${allData?.location?.coordinates?.[1]}`}
                                allowFullScreen
                            ></iframe>
                        </SoftBox>

                    </SoftBox>
                </SoftBox>

            </Card>

        </DashboardLayout>
    )
}

export default Index